module.exports = __webpack_public_path__ + "img/0220805141401.e37be962.jpg";